import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectProgressPercentage } from "../../store/selectors";
import { toggleBadgeModal } from "../../store/actions";
import useBadgeFilename from "../../hooks/useBadgeFilename";

const BadgeProgress = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const progress = useSelector(selectProgressPercentage);
  const lang = useSelector((state) => state.ui.lang);
  const shares = useSelector((state) => state.ui.shares);
  const badgeFilename = useBadgeFilename();

  const showBadgeModal = () => dispatch(toggleBadgeModal());

  return (
    <div onClick={showBadgeModal} className="my-3 cursor-pointer">
      {progress === 100 ? (
        <div className="flex items-center">
          <div className="h-12 w-12">
            <img src={`/images/badges/${badgeFilename}`} alt="" />
          </div>
          <div className="flex flex-col justify-center items-center ml-3 w-full">
            <div className="text-purple-800 text-center pb-1 text-sm">
              {t("Share the badge you've earned!")}
            </div>
            <div className="text-sm">
              {shares} {t("badgesShared")}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex">
          <div className="h-16 w-16">
            <img src={`/images/badges/${badgeFilename}`} alt="" />
          </div>
          <div className="ml-3 w-full mt-2">
            <div className="text-center pb-1 text-sm">{t("EARN YOUR BADGE")}</div>
            <div
              className="bg-purple-200 w-full rounded-lg"
              style={{
                height: "10px",
              }}
            >
              <div
                className="rounded-lg bg-purple-800"
                style={{
                  height: "10px",
                  width: `${progress}%`,
                  transition: "all .3s ease",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BadgeProgress;
